import produce from 'immer';
import { convertChannelCasing } from 'lib-shared-api-utils';
export const convertHitToMetaConversation = (hit) => {
    var _a;
    const metaConversation = {
        callersOnHold: [],
        conversation: produce({}, (draft) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            Object.assign(draft, {
                assignment: null,
                assignments: null,
                async_integrations: [],
                authors: undefined,
                created_at: hit.created_at,
                direction: hit.initial_direction,
                events: null,
                id: hit.numeric_id,
                initial_channel: convertChannelCasing(hit.initial_channel, 'truncate'),
                inboundmessagecount: hit.inboundmessagecount,
                live_assesment: null,
                is_closed: hit.status === 'closed',
                is_abandoned: false,
                last_seen: undefined,
                org_id: hit.organization_id,
                queue: null,
                ratings: [],
                requested_by: hit.requested_by,
                tags: [],
                last_message_created_at: (_a = hit.last_message_created_at) !== null && _a !== void 0 ? _a : null,
                outboundmessagecount: hit.outboundmessagecount,
                pending_expiration_at: null,
                pending_at: null,
                pending_by: null,
                status: hit.status,
                is_callback_consumed: false,
                numeric_id: hit.numeric_id,
            });
            if (hit.status === 'closed') {
                draft.closed_at = hit.closed_at;
            }
            if (hit.is_queued) {
                draft.queued_at = (_b = hit.queued_at) !== null && _b !== void 0 ? _b : null;
            }
            if (hit.initial_channel === 'email' ||
                hit.initial_channel === 'contact_form') {
                draft.attributes = {
                    forwarded_from_email: (_c = hit.forwardedfromemail) !== null && _c !== void 0 ? _c : '',
                    from_email: (_d = hit.fromemail) !== null && _d !== void 0 ? _d : '',
                    integration_email: (_e = hit.integrationemail) !== null && _e !== void 0 ? _e : '',
                    sender_name: (_g = (_f = hit.sendername) !== null && _f !== void 0 ? _f : '') !== null && _g !== void 0 ? _g : '',
                    subject: (_h = hit.subject) !== null && _h !== void 0 ? _h : '',
                    to_email: (_j = hit.toemail) !== null && _j !== void 0 ? _j : '',
                };
            }
        }),
        emailAddresses: null,
        extraParties: {},
        integrations: [],
        is_updating: false,
        isAssignedToMe: false,
        lastSeen: null,
        linkedConversations: [],
        messages: [],
        parentConversation: null,
        parentConversationRequester: null,
        previousConversations: null,
        requester: {
            id: (_a = hit.requested_by) !== null && _a !== void 0 ? _a : '',
            name: hit.requester_name,
            display_name: null,
            avatar_url: hit.requester_avatar,
            phone_number: hit.requester_phone,
            email: hit.requester_email,
            roles: [],
        },
        tempMessage: '',
        tempWrapup: '',
        unread: 0,
    };
    return metaConversation;
};
